import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../callback.pipes.module';

import { AddAssetWithinSceneModalPage } from './add-asset-within-scene-modal.page';

import { ResourceDirectivesModule } from '../../directives/resource-directives.module';

const routes: Routes = [
  {
    path: '',
    component: AddAssetWithinSceneModalPage
  }
];

@NgModule({
  imports: [
    ResourceDirectivesModule,
    FilterPipeModule,
    PipesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddAssetWithinSceneModalPage]
})
export class AddAssetWithinSceneModalPageModule { }
